import dataReport from '@/pages/dataReport/dataReport'
import layout from '@/components/layout/layout'
const dataReportRouter =
{
  path: '/dataReport',
  component: layout,
  meta: {roles: ['shop', 'pingtai', 'zhifa', 'factory', 'r4gys'], title: '数据看板', icon: 'icon-guanlibaobiaoon'},
  children: [
    {
      path: '/dataReport/echart',
      component: dataReport,
      name: 'dataReport',
      meta: {roles: ['shop', 'pingtai', 'zhifa', 'factory', 'r4gys'], title: '数据看板'}
    },
  ]
}
export default dataReportRouter



// WEBPACK FOOTER //
// ./src/router/modules/dataReportRouter.js